<template>
  <div class="advanced-form">
    <a-form>
      <div class="card">
        <div class="card-head">
          <h3>基本信息</h3>
        </div>
        <div class="card-body">
          <a-row type="flex">
            <a-col v-bind="$store.state.advanced_colWidth">
              <a-form-item class="value-indent" label="商品">
                <span  class="ant-form-text">{{detail.title}}</span>
              </a-form-item>
            </a-col>
            <a-col v-bind="$store.state.advanced_colWidth">
              <a-form-item class="value-indent" label="店铺名称">
                <span  class="ant-form-text">{{ detail.shopName }}</span>
              </a-form-item>
            </a-col>
            <a-col v-bind="$store.state.advanced_colWidth">
              <a-form-item class="value-indent" label="类型">
                <span  class="ant-form-text">{{ this.m.getOrderTypeDesc(detail.type) }}</span>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row type="flex">
            <a-col v-bind="$store.state.advanced_colWidth">
              <a-form-item class="value-indent" label="支付状态">
                <span  class="ant-form-text">{{ this.getOrderStatusTypeDesc(detail.orderStatus) }}</span>
              </a-form-item>
            </a-col>
            <a-col v-bind="$store.state.advanced_colWidth">
              <a-form-item class="value-indent" label="状态">
                <span  class="ant-form-text">{{ this.m.getUseStatusDesc(detail.useStatus) }}</span>
              </a-form-item>
            </a-col>
            <a-col v-bind="$store.state.advanced_colWidth">
              <a-form-item class="value-indent" label="售后状态">
                <span  class="ant-form-text">{{this.m.getSalesStatusTypeDesc(detail.salesStatus)}}</span>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row type="flex">
            <a-col v-bind="$store.state.advanced_colWidth">
              <a-form-item class="value-indent" label="结算状态">
                <span  class="ant-form-text">{{ this.m.getSettleStatusTypeDesc(detail.settleStatus) }}</span>
              </a-form-item>
            </a-col>
            <a-col v-bind="$store.state.advanced_colWidth"  v-if="!isProduct">
              <a-form-item class="value-indent" label="有效期">
                <span  class="ant-form-text">{{detail.expireDesc}}</span>
              </a-form-item>
            </a-col>
          </a-row>
        </div>
      </div>

      <div class="card" v-if="isProduct">
        <div class="card-head">
          <h3>物流信息</h3>
        </div>
        <div class="card-body">
          <a-row type="flex">
            <a-col v-bind="$store.state.advanced_colWidth">
              <a-form-item class="value-indent" label="收货人姓名">
                <span  class="ant-form-text">{{detail.receiverName}}</span>
              </a-form-item>
            </a-col>
            <a-col v-bind="$store.state.advanced_colWidth">
              <a-form-item class="value-indent" label="手机号">
                <span  class="ant-form-text">{{ detail.receiverPhone }}</span>
              </a-form-item>
            </a-col>
            <a-col v-bind="$store.state.advanced_colWidth">
              <a-form-item class="value-indent" label="地址">
                <span  class="ant-form-text">{{detail.receiverAddress}}</span>
              </a-form-item>
            </a-col>
          </a-row>

          <a-row type="flex">
            <a-col v-bind="$store.state.advanced_colWidth">
              <a-form-item class="value-indent" label="送货方式">
                <span  class="ant-form-text">{{detail.deliveryTypeDesc}}</span>
              </a-form-item>
            </a-col>
            <a-col v-bind="$store.state.advanced_colWidth" v-show="detail.deliveryType ==2">
              <a-form-item class="value-indent" label="物流公司名称">
                <span  class="ant-form-text">{{ detail.logisticsName }}</span>
              </a-form-item>
            </a-col>
            <a-col v-bind="$store.state.advanced_colWidth" v-show="detail.deliveryType ==2">
              <a-form-item class="value-indent" label="物流单号">
                <span  class="ant-form-text" v-show='detail.logisticsNo' @click = 'showLogisticsInfo'>{{ detail.logisticsNo }} <a>  查看物流信息</a></span>
              </a-form-item>
            </a-col>
            <a-col v-bind="$store.state.advanced_colWidth" v-if="detail.deliveryType ==3&&detail.localPickupPointLogisticsInfo">
              <a-form-item class="value-indent" label="自提点名称">
                <span  class="ant-form-text" v-if="detail.localPickupPointLogisticsInfo.pickupName">{{ detail.localPickupPointLogisticsInfo.pickupName }}</span>
              </a-form-item>
            </a-col>
            <a-col v-bind="$store.state.advanced_colWidth" v-if="detail.deliveryType ==3&&detail.localPickupPointLogisticsInfo">
              <a-form-item class="value-indent" label="自提点地址">
                <span  class="ant-form-text" v-if="detail.localPickupPointLogisticsInfo.area">{{ detail.localPickupPointLogisticsInfo.area }} </span>
              </a-form-item>
            </a-col>
          </a-row>

        </div>
      </div>

      <div class="card" v-if="isProduct">
        <div class="card-head">
          <h3>商品信息</h3>
        </div>
          <div class="card-body">
            <x-tabula
              ref="table"
              rowKey="id"
              :columns="newGoodsColumns"
              :rowSelection="false"
              :dataSource ="goodsInfoList"
            >
            <template slot="opt_img" slot-scope="{row}">
              <img style="height: 44px;width:auto" :src="row.imgUrl" alt="">
            </template>
          </x-tabula>
        </div>
      </div>

      <div class="card">
        <div class="card-head">
          <h3>订单信息</h3>
        </div>
        <div class="card-body">
          <a-row type="flex">
            <a-col v-bind="$store.state.advanced_colWidth">
              <a-form-item class="value-indent" label="订单号">
                <span  class="ant-form-text">{{ detail.orderId }}</span>
              </a-form-item>
            </a-col>
            <a-col v-bind="$store.state.advanced_colWidth">
              <a-form-item class="value-indent" label="下单时间">
                <span  class="ant-form-text">{{ detail.createTime }}</span>
              </a-form-item>
            </a-col>
            <a-col v-bind="$store.state.advanced_colWidth">
              <a-form-item class="value-indent" label="付款时间">
                <span  class="ant-form-text">{{detail.payTime}}</span>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row type="flex" v-if="!isProduct">
            <a-col v-bind="$store.state.advanced_colWidth">
              <a-form-item class="value-indent" label="数量">
                <span  class="ant-form-text">{{detail.totalCount}}</span>
              </a-form-item>
            </a-col>
            <a-col v-bind="$store.state.advanced_colWidth">
              <a-form-item class="value-indent" label="总价">
                <span  class="ant-form-text">{{detail.totalFee|toMoney}}</span>
              </a-form-item>
            </a-col>
            <a-col v-bind="$store.state.advanced_colWidth">
              <a-form-item class="value-indent" label="平台优惠">
                <span  class="ant-form-text">{{detail.platformVoucherAmount|toMoney}}</span>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row type="flex" v-if="isProduct">
            <a-col v-bind="$store.state.advanced_colWidth">
              <a-form-item class="value-indent" label="数量">
                <span  class="ant-form-text">{{detail.totalCount}}</span>
              </a-form-item>
            </a-col>
            <a-col v-bind="$store.state.advanced_colWidth">
              <a-form-item class="value-indent" label="运费">
                <span  class="ant-form-text">{{detail.freight|toMoney}}</span>
              </a-form-item>
            </a-col>
            <a-col v-bind="$store.state.advanced_colWidth">
              <a-form-item class="value-indent" label="总价">
                <span  class="ant-form-text">{{detail.totalFee|toMoney}}</span>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row type="flex" v-if="isProduct">
            <a-col v-bind="$store.state.advanced_colWidth">
              <a-form-item class="value-indent" label="平台优惠">
                <span  class="ant-form-text">{{detail.platformVoucherAmount|toMoney}}</span>
              </a-form-item>
            </a-col>
            <a-col v-bind="$store.state.advanced_colWidth">
              <a-form-item class="value-indent" label="商家优惠">
                <span  class="ant-form-text">{{detail.shopVoucherAmount|toMoney}}</span>
              </a-form-item>
            </a-col>
            <a-col v-bind="$store.state.advanced_colWidth">
              <a-form-item class="value-indent" label="实付">
                <span  class="ant-form-text">{{detail.payFee|toMoney}}</span>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row type="flex" v-if="!isProduct">
            <a-col v-bind="$store.state.advanced_colWidth">
              <a-form-item class="value-indent" label="商家优惠">
                <span  class="ant-form-text">{{detail.shopVoucherAmount|toMoney}}</span>
              </a-form-item>
            </a-col>
            <a-col v-bind="$store.state.advanced_colWidth">
              <a-form-item class="value-indent" label="实付">
                <span  class="ant-form-text">{{detail.payFee|toMoney}}</span>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row type="flex">
            <a-col v-bind="$store.state.advanced_colWidth">
              <a-form-item class="value-indent" label="昵称">
                <span  class="ant-form-text">{{ detail.nickName }}</span>
              </a-form-item>
            </a-col>
            <a-col v-bind="$store.state.advanced_colWidth">
              <a-form-item class="value-indent" label="手机号">
                <span  class="ant-form-text">{{ detail.mobile }}</span>
              </a-form-item>
            </a-col>
          </a-row>
        </div>
      </div>

      <div class="card" v-if="this.$route.query.type == 1">
        <div class="card-head">
          <h3>团购详情</h3>
        </div>
        <div class="card-body">
          <div v-for="(item) in detail.goodsItemInfo" v-bind:key=item.itemId>
            <div v-if="item.type===1" class="goodsItems-father">
              <div class="goodsItems-item">
                {{ item.title }}
              </div>
            </div>
            <div v-else class="goodsItems-children">
              <div class="goodsItems-item">
                · {{ item.title }}
              </div>
              <div v-if="item.type !==3" class="goodsItems-item">
                <!-- ({{ item.number }}{{item.unit}}) -->
              </div>
              <div v-if="item.type !==3" class="goodsItems-item">

                  <span class='card_txt'>({{ item.number }}{{item.unit}})</span><span class='card_txt'>{{ item.price|toMoney }}</span>
              </div>
            </div>
          </div>
          <div style="width:33%;float:right"><span style="font-weight: bolder;position:relative;left:8px;"  class='card_txt'>总价值：</span><span  class='card_txt'>{{detail.originalPrice|toMoney }}</span></div>
        </div>
      </div>

      <div class="card">
        <div class="card-head">
          <h3>结算信息</h3>
        </div>
        <div class="card-body">
          <x-tabula
            ref="table"
            rowKey="id"
            :dataSource="settleInfoList"
            :columns="newBalanceColumns"
            :rowSelection="false"
          >
          </x-tabula>
        </div>
    </div>

    </a-form>
    <logisticsInfo ref='logisticsInfoModel'></logisticsInfo>
  </div>
</template>

<script>
import logisticsInfo from '../component/logisticsInfo.vue';
export default {
  name: 'localOrderDetail',
  components: {logisticsInfo},
  data () {
    return {
      typeArr: [],
      goodsInfoList: undefined,
      settleInfoList: undefined,
      goodsInfoHead: undefined,
      settleInfoHead: undefined,
      isProduct: false,
      m: {},
      detail: {},
      newGoodsColumns: [
        { title: '图片', dataIndex: 'imgUrl', align: 'center', width: '', scopedSlots: { customRender: 'img' }}
      ],
      goodsColumns: [
        { title: '图片', dataIndex: 'imgUrl', align: 'center', width: '', scopedSlots: { customRender: 'img' }},
        { title: '名称', dataIndex: 'title', align: 'center', width: '' },
        { title: '', dataIndex: 'spec1', align: 'center', width: '' },
        { title: '', dataIndex: 'spec2', align: 'center', width: '' },
        { title: '', dataIndex: 'spec3', align: 'center', width: '' },
        { title: '数量', dataIndex: 'number', align: 'center', width: ''},
        { title: '单价', dataIndex: 'price', align: 'center', width: '', customCell: (row) => ({ domProps: { innerHTML: row.price ? '￥' + row.price : '￥0'} })},
        { title: '商品小计', dataIndex: 'totalPrice', align: 'center', width: '', customCell: (row) => ({ domProps: { innerHTML: row.totalPrice ? '￥' + row.totalPrice : '￥0'} })}
      ],
      newBalanceColumns: [
        { title: '券码', dataIndex: 'ticketCode', align: 'center', width: ''},
        { title: '单价', dataIndex: 'price', align: 'center', width: '', customCell: (row) => ({ domProps: { innerHTML: row.price ? '￥' + row.price : '￥0'} })},
        { title: '平台优惠', dataIndex: 'platformVoucherAmount', align: 'center', width: '', customCell: (row) => ({ domProps: { innerHTML: row.platformVoucherAmount ? '￥' + row.platformVoucherAmount : '￥0'} })},
        { title: '商家优惠', dataIndex: 'shopVoucherAmount', align: 'center', width: '', customCell: (row) => ({ domProps: { innerHTML: row.shopVoucherAmount ? '￥' + row.shopVoucherAmount : '￥0'} })},
        { title: '用户实付', dataIndex: 'ticketFee', align: 'center', width: '', customCell: (row) => ({ domProps: { innerHTML: row.ticketFee ? '￥' + row.ticketFee : '￥0'} })},
        { title: '商家实收', dataIndex: 'realFee', align: 'center', width: '', customCell: (row) => ({ domProps: { innerHTML: row.realFee ? '￥' + row.realFee : '￥0'} })},
        { title: '技术服务费', dataIndex: 'platformServiceFee', align: 'center', width: '', customCell: (row) => ({ domProps: { innerHTML: row.platformServiceFee ? '￥' + row.platformServiceFee : '￥0'} })},
        { title: '商家预计收入', dataIndex: 'expectFee', align: 'center', width: '', customCell: (row) => ({ domProps: { innerHTML: row.expectFee ? '￥' + row.expectFee : '￥0'} })},
        { title: '分销佣金', dataIndex: 'commissionFee', align: 'center', width: '', customCell: (row) => ({ domProps: { innerHTML: row.commissionFee ? '￥' + row.commissionFee : '￥0'} })},
        { title: '结算状态', dataIndex: 'statusDesc', align: 'center', width: ''}
      ],
      balanceColumns: [
        { title: '', dataIndex: 'spec1', align: 'center', width: ''},
        { title: '', dataIndex: 'spec2', align: 'center', width: ''},
        { title: '', dataIndex: 'spec3', align: 'center', width: ''},
        { title: '单价', dataIndex: 'price', align: 'center', width: '', customCell: (row) => ({ domProps: { innerHTML: '￥' + row.price} })},
        { title: '平台优惠', dataIndex: 'platformVoucherAmount', align: 'center', width: '', customCell: (row) => ({ domProps: { innerHTML: '￥' + row.platformVoucherAmount} })},
        { title: '商家优惠', dataIndex: 'shopVoucherAmount', align: 'center', width: '', customCell: (row) => ({ domProps: { innerHTML: '￥' + row.shopVoucherAmount} })},
        { title: '运费', dataIndex: 'freight', align: 'center', width: '', customCell: (row) => ({ domProps: { innerHTML: row.freight ? '￥' + row.freight : '￥0'} })},
        { title: '用户实付', dataIndex: 'payFee', align: 'center', width: '', customCell: (row) => ({ domProps: { innerHTML: row.payFee ? '￥' + row.payFee : '￥0'} })},
        { title: '商家实收', dataIndex: 'realFee', align: 'center', width: '', customCell: (row) => ({ domProps: { innerHTML: '￥' + row.realFee} })},
        { title: '技术服务费', dataIndex: 'platformServiceFee', align: 'center', width: '', customCell: (row) => ({ domProps: { innerHTML: '￥' + row.platformServiceFee} })},
        { title: '商家预计收入', dataIndex: 'expectFee', align: 'center', width: '', customCell: (row) => ({ domProps: { innerHTML: '￥' + row.expectFee} })},
        { title: '分销佣金', dataIndex: 'commissionFee', align: 'center', width: '', customCell: (row) => ({ domProps: { innerHTML: '￥' + row.commissionFee} })},
        { title: '结算状态', dataIndex: 'settleStatusDesc', align: 'center', width: ''}
      ],
      tableData: []
    };
  },
  beforeCreate () {
    this.form = this.$form.createForm(this);
  },
  beforeRouteEnter (to, from, next) {
    next();
    setTimeout(() => {
      document.getElementsByClassName('layout-content')[0].style.padding = '0px';
      document.getElementsByClassName('layout-content')[0].style.backgroundColor = 'transparent';
    }, 0);
  },
  beforeRouteLeave (to, from, next) {
    document.getElementsByClassName('layout-content')[0].style.padding = '16px';
    document.getElementsByClassName('layout-content')[0].style.backgroundColor = '#fff';
    next();
  },
  filters: {
    toMoney (val) {
      if (val != null) {
        return '￥' + Number(val).toFixed(2);
      } else {
        return '';
      }
    }
  },
  created () {
    if (this.$route.query.type == 3) {
      this.isProduct = true;
    }
    this.$get({
      url: '/dict/data/dictType/comu_local_order_status',
      params: {}
    }).then(({data}) => {
      this.typeArr = data;
    });
  },
  mounted () {
    this.m = this.$route.query.methods;
    if (this.$route.query.id) {
      this.getDetail();
    }
  },
  methods: {
    // 获取支付状态
    getOrderStatusTypeDesc (type) {
      for (let i = 0; i < this.typeArr.length; i++) {
        if (this.typeArr[i].value === type + '') {
          return this.typeArr[i].label;
        }
      }
    },
    traverseHeader () {
      Object.keys(this.goodsInfoHead).forEach(key => {
        if (key == 'spec1' || key == 'spec2' || key == 'spec3') {
          this.goodsColumns.filter(item => item.dataIndex == key)[0].title = this.goodsInfoHead[key];
        }
      });
      this.newGoodsColumns = [].concat(this.goodsColumns.filter(item => item.title));

      Object.keys(this.settleInfoHead).forEach(key => {
        if (key == 'spec1' || key == 'spec2' || key == 'spec3') {
          this.balanceColumns.filter(item => item.dataIndex == key)[0].title = this.settleInfoHead[key];
        }
      });
      this.newBalanceColumns = this.balanceColumns.filter(item => item.title);
      this.newBalanceColumns.filter(item => item.dataIndex == 'platformServiceFee')[0].title = '技术服务费(' + (this.detail.platformServicePoint ? this.detail.platformServicePoint : '0') + '%)';
    },
    showLogisticsInfo () {
      if (this.detail.logisticsCode && this.detail.logisticsNo) {
        this.$refs.logisticsInfoModel.show(this.detail.logisticsCode, this.detail.logisticsNo);
      }
    },
    getDetail () {
      if (!this.isProduct) {
        this.$get({
          url: `/local/order/ticket/${this.$route.query.id}`,
          params: {}
        }).then(({data}) => {
          this.detail = data;
          this.tableData = data.detailList;
          this.settleInfoList = data.settleInfoList;
          this.newBalanceColumns[6].title = '技术服务费(' + (this.detail.platformServicePoint ? this.detail.platformServicePoint : '0') + '%)';
        });
      } else {
        this.$get({
          url: `/local/order/goods/${this.$route.query.id}`,
          params: {}
        }).then(({data}) => {
          this.detail = data;
          this.tableData = data.detailList;
          this.goodsInfoHead = data.goodsInfoHead;
          this.settleInfoHead = data.settleInfoHead;
          this.traverseHeader();
        });
        this.$get({
          url: `/local/order/goods/detailList/${this.$route.query.id}`,
          params: {}
        }).then(({data}) => {
          this.goodsInfoList = data.goodInfoList;
          this.settleInfoList = data.settleInfoList;
        });
      }
    }
  }
};
</script>

<style scoped>
.card_txt{
  display: inline-block;
  width:100px;
  text-align: right;
}
.goodsItems-father {
  display: flex;
  font-size: 14px;
  font-weight: bolder;
  padding-left: 10px;
}
.goodsItems-children{
  display: flex;
  padding-left: 20px;
}
.goodsItems-item{
  width: 33.33%;
}
</style>
